import { Box, Typography } from '@mui/material';
import MarkdownRenderer from '../MarkdownRenderer';

// Accept groupMessages (array) and profile, and render each message
const GroupMessageBox = ({ groupMessages, profile }) => {
    return (
        <>
            {groupMessages?.map((message, index) => (
                <Box
                    key={message?.uuid || message?.id || index}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems:
                            message?.from === profile?.uuid ? 'end' : 'start',
                        gap: '2px',
                        py: '2px'
                    }}
                >
                    <Box
                        className={
                            message?.from === profile?.uuid
                                ? 'bg-slate-200'
                                : 'bg-sky-200'
                        }
                        sx={{
                            maxWidth: '200px !important',
                            boxSizing: 'border-box',
                            px: '16px',
                            pt: '8px',
                            pb: '2px',
                            borderRadius:
                                message?.from === profile?.uuid
                                    ? '8px 0px 8px 8px'
                                    : '0px 8px 8px 8px'
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'flex-end'
                            }}
                        >
                            <Typography
                                variant="body2"
                                component="pre"
                                sx={{
                                    whiteSpace: 'pre-wrap',
                                    wordWrap: 'break-word',
                                    textAlign: 'start',
                                    marginBottom: '4px',
                                    width: '100%',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}
                            >
                                <MarkdownRenderer>
                                    {message?.body ||
                                        `Say hi to ${
                                            message?.from === profile?.uuid
                                                ? 'me'
                                                : 'you'
                                        }`}
                                </MarkdownRenderer>
                            </Typography>
                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns:
                                        message?.files &&
                                        message?.files.length > 1
                                            ? 'repeat(2, 1fr)'
                                            : '1fr',
                                    gap: '10px'
                                }}
                            >
                                {message?.files &&
                                    message?.files?.map((file, idx) => {
                                        if (
                                            file?.file_type === 'image/jpeg' ||
                                            file?.file_type === 'image/png'
                                        ) {
                                            return (
                                                <Box key={idx}>
                                                    <img
                                                        src={`/chat-media/${file?.file_url}`}
                                                        alt="file"
                                                        style={{
                                                            width: '150px',
                                                            height: '150px',
                                                            borderRadius: '8px',
                                                            objectFit: 'cover'
                                                        }}
                                                    />
                                                </Box>
                                            );
                                        }
                                        return null;
                                    })}
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                textAlign: 'end',
                                display: 'flex',
                                gap: '4px',
                                justifyContent: 'end',
                                alignItems: 'end'
                            }}
                        >
                            <Typography
                                sx={{
                                    color: 'text.secondary',
                                    fontSize: '0.73rem'
                                }}
                            >
                                {formatTime(message?.created_at)}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            ))}
        </>
    );
};

// Function to format date to HH:MM AM/PM in user timezone
const formatTime = (dateString) => {
    const date = new Date(dateString);

    return date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: 'numeric'
    });
};

export default GroupMessageBox;
